declare global {
  interface Window {
    gtag: (...args: unknown[]) => void
    dataLayer: unknown[]
  }
}
export const trackEvent = (event: string, data: Record<string, any>) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', event, data)
  } else if (import.meta.env.DEV) {
    console.debug('gtag (not loaded):', event, data)
  }
}
export const trackPageview = (path: string) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', { page_path: path })
  }
}